"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const base_ui_components_atoms__atoms_1 = require("@motorata/base-ui.components.atoms._atoms");
const base_ui_components_atoms_typography_1 = require("@motorata/base-ui.components.atoms.typography");
const base_ui_components_atoms_spinner_1 = __importDefault(require("@motorata/base-ui.components.atoms.spinner"));
const base_ui_utils_finance_1 = require("@motorata/base-ui.utils.finance");
const RateTitle = (_a) => {
    var { title, loading, rate, rateRight = "zł", rateBottom = "netto", marginTop = "S", marginBottom = "S" } = _a, rest = __rest(_a, ["title", "loading", "rate", "rateRight", "rateBottom", "marginTop", "marginBottom"]);
    return (react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, Object.assign({ marginTop: marginTop, marginBottom: marginBottom, justifyContent: "space-between", alignItems: "flex-start", position: "relative" }, rest),
        react_1.default.createElement(base_ui_components_atoms_typography_1.Label, { type: "secondary", margin: "0" }, title),
        react_1.default.createElement(base_ui_components_atoms__atoms_1.Row, { flexDirection: "column", alignItems: "flex-end", marginLeft: "M", opacity: loading ? 0 : 1 },
            react_1.default.createElement(base_ui_components_atoms_typography_1.RateLabel, { color: "primary" },
                rate && (0, base_ui_utils_finance_1.formatPrice)(rate),
                " ",
                react_1.default.createElement("span", null, rateRight)),
            react_1.default.createElement(base_ui_components_atoms_typography_1.LabelH3, { margin: "0", color: "primary" }, rateBottom)),
        loading && (react_1.default.createElement(base_ui_components_atoms__atoms_1.Absolute, { height: "100%", right: "1rem" },
            react_1.default.createElement(base_ui_components_atoms__atoms_1.Column, { height: "100%", justifyContent: "center" },
                react_1.default.createElement(base_ui_components_atoms_spinner_1.default, null))))));
};
exports.default = RateTitle;
//# sourceMappingURL=RateTitle.js.map